import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import TopNavBar from './TopNavBar';
import ClientSidebar from './ClientSidebar';

/** Shell for the Client Admin experience: fixed top bar + sidebar. */
export default function ClientLayout() {
  const [navOpen, setNavOpen] = useState(false);

  return (
    <div className="min-h-screen bg-brand-bg">
      {/* No org picker on the client side — the org/state come from the logged-in user. */}
      <TopNavBar onMenuClick={() => setNavOpen(true)} showUtilityIcons={false} showOrgPicker={false} />
      <ClientSidebar open={navOpen} onClose={() => setNavOpen(false)} />
      <main className="mt-16 p-4 sm:p-6 lg:ml-[280px]">
        <Outlet />
      </main>
    </div>
  );
}
